import { useEffect } from 'react';
import {
  useStore as useFileViewerStore,
  FileState,
} from '@morph-mapper/file-viewer';
import { SchemaVariant } from '@morph-mapper/types';
import {
  createHighlightsForPosition,
  type Position,
} from './highlight-manager';

export const useHighlightManager = (position: Position | undefined) => {
  const [setHighlights, getVariant] = useFileViewerStore(
    (s: { file: FileState }) => [s.file.setHighlights, s.file.getVariant],
  );

  useEffect(() => {
    if (!position) {
      // Do not clear highlights when there is no position; keep previous highlights
      return;
    }

    const variant = getVariant();
    if (variant === null) {
      return;
    }

    const highlights = createHighlightsForPosition(position, variant);

    if (highlights.length > 0) {
      setHighlights(highlights);
    }
  }, [position, setHighlights, getVariant]);
};
